'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 删除script对象
 * @param {*} script
 */
function removeScript(script) {
    if (script && script.parentNode) {
        script.parentNode.removeChild(script);
    }
}

/**
 * 加载script对象
 */
function loadScript(_ref) {
    var url = _ref.url,
        attrs = _ref.attrs,
        timeout = _ref.timeout;

    var timer = null;
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';

        for (var key in attrs) {
            if (Object.hasOwnProperty.call(attrs, key)) {
                script.setAttribute(key, attrs[key]);
            }
        }

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (!script) {
                    return;
                }

                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;

                    // Remove the script
                    removeScript(script);

                    script = null;
                    clearTimeout(timer);
                    resolve();
                }
            };
        } else {
            script.onload = function () {
                // Remove the script
                removeScript(script);
                script = null;
                clearTimeout(timer);
                resolve();
            };

            script.onerror = function () {
                // Remove the script
                removeScript(script);
                script = null;
                clearTimeout(timer);
                reject();
            };
        }

        // 增加超时处理
        timer = setTimeout(function () {
            // Remove the script
            removeScript(script);
            script = null;
            reject();
        }, timeout);

        script.src = url;
        // document.head.appendChild(script);
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}

exports.default = loadScript;